// extracted by mini-css-extract-plugin
export default {"smsContent":"SnapppayPayments_smsContent__39H47","ltr":"SnapppayPayments_ltr__thgqz","rtl":"SnapppayPayments_rtl__aHdM9"};